import { render, staticRenderFns } from "./SaldoSaques.vue?vue&type=template&id=4202ed36"
import script from "./SaldoSaques.vue?vue&type=script&lang=js"
export * from "./SaldoSaques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports